import _ from 'underscore';
import Ajax from 'legacy/ajax';

function ResumeParser(fromResume: any) {
  // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
  this.fromResume = fromResume;
  // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
  this.parserUrl = this.fromResume.$form.attr('action');
}

ResumeParser.prototype.post = function (data: any) {
  Ajax.post({
    dataType: 'json',
    url: this.parserUrl,
    data: data,
    success: this.success.bind(this),
    error: this.errorFunc(data).bind(this),
    always: this.fromResume.closeModal.bind(this.fromResume),
    disableFlash: true,
  });
};

ResumeParser.prototype.success = function (data: any) {
  this.fromResume.uploadedAndParsedResume({ result: data });
};

ResumeParser.prototype.errorFunc = function (data: any) {
  return function (event: any) {
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    this.error(event, data);
  };
};

ResumeParser.prototype.error = function (event: any, data: any) {
  const result = _.extend({}, event, data.resume, data);
  this.fromResume.uploadedAndParsedResume({ result: result });
};

export default ResumeParser;
